export function DisabledAccountsToggle({ showDisabledOnly, disabledCount, onToggle }) {
  return (
    <button
      type="button"
      className={`disabled-accounts-btn${
        showDisabledOnly ? ' disabled-accounts-btn--active' : ''
      }`}
      onClick={onToggle}
      title={
        showDisabledOnly
          ? 'Return to active accounts'
          : 'Show accounts hidden from the dashboard'
      }
    >
      {showDisabledOnly
        ? '← Active accounts'
        : `View disabled accounts${disabledCount ? ` (${disabledCount})` : ''}`}
    </button>
  );
}

export function DisabledAccountsBanner({ segment, count }) {
  if (!count) return null;
  return (
    <span className="disabled-accounts-banner" role="status">
      Viewing <strong>{count}</strong> disabled {segment.toUpperCase()} account
      {count === 1 ? '' : 's'} — enable to show in tables again
    </span>
  );
}
